import { Injectable, signal } from '@angular/core';
import { SaveRecommededRouteTechModeItem } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class RecommededRouteCardData {
  private _recommendedRouteCardData = signal<SaveRecommededRouteTechModeItem | null>(null);
  public recommendedRouteCardData = this._recommendedRouteCardData.asReadonly();
  
  public setRecommendedRouteCardData(data: SaveRecommededRouteTechModeItem): void {
    this._recommendedRouteCardData.set(data);
  }
  
  public updateRecommendedRouteCardData(data: Partial<SaveRecommededRouteTechModeItem>): void {
    this._recommendedRouteCardData.update((prev) => ({
      ...prev,
      ...data,
    }));
  }
}
